export default {
    locationRefreshInterval: 10000,
    minimumMoveToUpdate: 200,
}
